import { SignIn, useAuth } from "@clerk/react"
import { Navigate } from "@tanstack/react-router"

import { AuthShell } from "@/features/auth/auth-shell"

interface FleetSafetySuperAdminSignInPageProps {
  path?: string
  redirectUrl?: string
}

function resolveFleetSafetySuperAdminDestination(redirectUrl: string | undefined) {
  const normalized = redirectUrl?.trim()

  if (!normalized) {
    return "/fleet"
  }

  const compactedPath = normalized.replace(/\/{2,}/g, "/")
  const rootRelativePath = compactedPath.startsWith("/") ? compactedPath : undefined

  if (!rootRelativePath) {
    return "/fleet"
  }

  if (rootRelativePath.toLowerCase().includes("bladesafety")) {
    return "/fleet"
  }

  return rootRelativePath
}

export function FleetSafetySuperAdminSignInPage({
  path = "/fleet-safety/super-admin",
  redirectUrl,
}: FleetSafetySuperAdminSignInPageProps) {
  const { isSignedIn, isLoaded } = useAuth()
  const destination = resolveFleetSafetySuperAdminDestination(redirectUrl)

  if (isLoaded && isSignedIn) {
    return <Navigate to={destination} replace />
  }

  return (
    <AuthShell
      title="Fleet Safety super admin sign in"
      description="Sign in to Fleet Safety operations and customer provisioning."
    >
      <SignIn
        appearance={{
          elements: {
            headerTitle: "hidden",
            headerSubtitle: "hidden",
          },
        }}
        fallbackRedirectUrl={destination}
        path={path}
        routing="path"
        signUpUrl="/fleet-invite"
      />
    </AuthShell>
  )
}
